import { render, staticRenderFns } from "./addReference.vue?vue&type=template&id=617bab44&scoped=true"
import script from "./addReference.vue?vue&type=script&lang=js"
export * from "./addReference.vue?vue&type=script&lang=js"
import style0 from "./addReference.vue?vue&type=style&index=0&id=617bab44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617bab44",
  null
  
)

export default component.exports